export interface ApiResponse<T = unknown> {
  success: boolean
  message: string
  data: T
  error: ApiErrorBody | null
  meta: PaginationMeta | null
}

export interface ApiErrorBody {
  code: string
  details: ValidationDetail[] | null
}

export interface ValidationDetail {
  field: string
  issue: string
}

export interface PaginationMeta {
  total: number
  page: number
  per_page: number
  total_pages: number
  [key: string]: unknown
}

export class ApiError extends Error {
  readonly code: string
  readonly status: number
  readonly details: ValidationDetail[] | null
  readonly meta: Record<string, unknown> | null

  constructor(
    message: string,
    status: number,
    code: string,
    details: ValidationDetail[] | null = null,
    meta: Record<string, unknown> | null = null,
  ) {
    super(message)
    this.name = 'ApiError'
    this.status = status
    this.code = code
    this.details = details
    this.meta = meta
  }

  get isValidation() {
    return this.code === 'validation_error'
  }

  get isUnauthorized() {
    return this.code === 'unauthorized'
  }

  get isForbidden() {
    return this.code === 'forbidden'
  }

  get isNotFound() {
    return this.code === 'not_found'
  }

  get isRateLimited() {
    return this.code === 'rate_limited'
  }

  fieldError(field: string): string | undefined {
    return this.details?.find((d) => d.field === field)?.issue
  }
}
